import { factory, getResponseCamelization } from '@repo-level/core-front';
import {
  CMSApiBase,
  CMSCountryParams,
  CMSImageBase,
  CMSScheduler,
  buildCmsUrl,
  getResponseCMS,
} from './base';
import { CMS_URL, isCMSV3 } from 'helpers/conf';

export interface CMSGameTheme
  extends CMSApiBase,
    CMSScheduler,
    CMSCountryParams {
  categoryId: string;
  title: string;
  order: number;
  smallBanner: CMSImageBase;
  largeBanner: CMSImageBase;
  character: CMSImageBase;
}

export const gameThemesV3 = factory((r) => (lang: string) =>
  r<CMSGameTheme[]>('get', `${CMS_URL}/game-themes?_locale=${lang}`)
);

export const gameThemesV4 = factory((r) => (lang: string) =>
  r<CMSGameTheme[]>(
    'get',
    buildCmsUrl({
      path: 'game-themes',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const gameThemes = isCMSV3 ? gameThemesV3 : gameThemesV4;
